import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapFields } from "@joandvgv/vuex-map-fields";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import AutomationDropdown from "./dropdown";
import TriggerArguments from "./trigger-arguments";
import ActionArguments from "./action-arguments";
import AutomationShareSelection from "./automation-share-selection";
import AutomationEditor from "./automation-editor";
import AutomationSaved from "./automation-saved";
import { mapState, mapActions } from "vuex";
import { LOAD_PLAN_LIMIT } from "@Broker/@Modules/account-plan/store/account-plan-actions";
import { DELETE_AUTOMATION } from "../store/automation-actions";
import Amplitude from "../../../../../../shared/utils/amplitude";
import { isEmpty, isNull, isObject, isString, some, values } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BoardLevelAutomations",
  title() {
    return this.$t("sidebar.sections.automation");
  },
  components: {
    SimpleButton,
    AutomationDropdown,
    TriggerArguments,
    ActionArguments,
    AutomationShareSelection,
    AutomationEditor,
    AutomationSaved
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AutomationStore", {
    loading: "loading",
    savingStatus: "savingStatus",
    saving: "saving",
    editing: "editing",
    triggers: state => values(state.automationData.entities.trigger),
    actions: state => values(state.automationData.entities.action),
    shareSelection: "shareSelection"
  })), mapFields("AutomationStore", ["deleting", "automationToDelete"])), mapState("AccountPlanStore", ["currentPagePlan"])), {}, {
    shouldShowActionSelect() {
      const hasTrigger = !isEmpty(this.automationToDelete.trigger);
      const allArgumentsFilled = this.allArgumentsFilled(this.automationToDelete.triggerArguments, this.automationToDelete.trigger["trigger-arguments"]);
      return hasTrigger && allArgumentsFilled;
    },
    shouldShowSave() {
      const hasAction = !isEmpty(this.automationToDelete.action);
      const hasActionArguments = !isEmpty(this.automationToDelete.actionArguments);
      const allArgumentsFilled = this.allArgumentsFilled(this.automationToDelete.actionArguments, this.automationToDelete.action["action-arguments"]);
      return hasAction && hasActionArguments && allArgumentsFilled;
    },
    emptyAutomationToDeleteTrigger() {
      return isEmpty(this.automationToDelete.trigger["trigger-arguments"]);
    },
    emptyAutomationToDeleteAction() {
      return isEmpty(this.automationToDelete.action["trigger-arguments"]);
    }
  }),
  watch: {
    deleting(newValue) {
      this.$nextTick(() => {
        this.saving = true;
        const modal = $(this.$refs["deleteModal"]);
        if (newValue) {
          modal.modal("show");
        } else {
          modal.modal("hide");
        }
      });
    }
  },
  beforeMount() {
    Amplitude.logEvent("Automations - board level visited");
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("AutomationStore", [DELETE_AUTOMATION])), {}, {
    cancelDelete() {
      this.deleting = false;
    }
  }, mapActions("AccountPlanStore", [LOAD_PLAN_LIMIT])), {}, {
    async acceptDelete() {
      await this.DELETE_AUTOMATION();
      await this.LOAD_PLAN_LIMIT(this.currentPagePlan);
    },
    allArgumentsFilled(args, parent) {
      //If no arguments, all are filled
      if (isNull(parent)) return true;
      return !some(values(args), value => {
        if (isString(value)) {
          return value === "";
        } else if (isObject(value)) {
          return some(values(value), value => isEmpty(value) || isNull(value));
        } else {
          return isEmpty(value);
        }
      });
    },
    getKey(obj) {
      if (obj) {
        return obj.key;
      } else {
        return Math.random();
      }
    },
    backToShareSelect() {
      this.shareSelection = false;
    }
  })
});